import { Component, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';

export interface ConfirmModel {
  title: string;
  message: string;
  extra: string ;
  confirmButtonText: string;
  cancelButtonText: string;
}

@Component({
  selector: 'confirm',
  template: `<div class="modal-dialog">
                <div class="modal-content">
                   <div class="modal-header badge-primary">
                      <h4 class="modal-title">{{title || 'Confirm'}}</h4>
                      <button type="button" class="close" (click)="close()" >&times;</button>
                   </div>
                   <div class="modal-body">
                     <p class="h6">{{message || 'Are you sure?'}}</p>
                     <small class="extra-clr">{{extra}}</small>
                   </div>
                   <div class="modal-footer">
                     <button type="button" class="btn btn-primary" style="min-width:20%" (click)="confirm()">{{confirmButtonText || Yes}}</button>
                     <button type="button" class="btn btn-default" style="min-width:20%" (click)="cancel()" #setfocus>{{cancelButtonText || No}}</button>
                   </div>
                 </div>
                </div>`
})
export class ConfirmComponent extends DialogComponent<ConfirmModel, boolean> implements ConfirmModel {
  title: string;
  message: string;
  extra = '';
  confirmButtonText: string;
  cancelButtonText: string;
  No: any;
  Yes: any;

  constructor(dialogService: DialogService) {
    super(dialogService);
  }

  @ViewChild('setfocus', { static: true }) private elementref: ElementRef
  public ngAfterViewInit(): void {
    this.elementref.nativeElement.focus();
  }

  confirm() {
    // on click on confirm button we set dialog result as true,
    // ten we can get dialog result from caller code
    this.result = true;
    this.close();
  }
  cancel() {
    this.result = false;
    this.close();
  }
}
